import { getRiskSave, getRiskSign } from '../../../api/risk';

const mixin = {
  created() {
    this.$bridge.registerHandler('getSignData', (data) => {
      console.log(data);
      this.$_handleRiskSign(data);
    });
  },
  methods: {
    /**
     * 保存问卷结果
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    $_handleRiskSave(evaluationResultFileSign = null) {
      const toast = this.$createToast({
        txt: '加载中...',
        type: 'loading',
        mask: true,
        time: 0,
      }).show();
      const saveData = {
        sysCode: this.managerInfo.sysCode,
        managerAdminUserId: this.managerInfo.managerAdminUserId,
        userId: this.managerInfo.invenstemUserId,
        evaluationResultFile: this.riskResult.evaluationResultFile,
        evaluationResultFileSign,
        answerJsonStr: this.riskResult.userAnswer,
        afterResult: this.riskResult.evaluationResult,
      };
      getRiskSave(saveData, this.au).then((res) => {
        toast.hide();
        if (res.code === 0) {
          this.$bridge.callHandler('getResult', { msg: '最后确认', level: res.data.bean.evaluationResult }, () => {
          });
        } else {
          this.$createToast({
            type: 'txt',
            txt: res.msg,
            mask: true,
            time: 2000,
          }).show();
        }
      });
    },
    /**
     * 签名合成
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    $_handleRiskSign(str) {
      const toast = this.$createToast({
        txt: '签名合成中...',
        type: 'loading',
        mask: true,
        time: 0,
      }).show();
      const signData = {
        sysCode: this.managerInfo.sysCode,
        managerAdminUserId: this.managerInfo.managerAdminUserId,
        userId: this.managerInfo.invenstemUserId,
        platformUserId: this.managerInfo.platformUserId,
        evaluationResultFile: this.riskResult.evaluationResultFile,
        signImagesFileInfo: str,
      };
      getRiskSign(signData, this.au).then((res) => {
        toast.hide();
        if (res.code === 0) {
          this.$_handleRiskSave(res.data.bean.evaluationResultFileSign);
        } else {
          this.$createToast({
            type: 'txt',
            txt: res.msg,
            mask: true,
            time: 2000,
          }).show();
        }
      }).catch((e) => {
        toast.hide();
        this.$createToast({
          type: 'txt',
          txt: `合成错误:${e}:${e.message}`,
          mask: true,
          time: 2000,
        }).show();
        return Promise.reject(e);
      });
    },
  },
};
export default mixin;
